import script from "./PersonalDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalDetailsPage.vue?vue&type=style&index=0&id=007975ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007975ef"]])

export default __exports__